// src/context/UserContext.js

import React, { createContext, useState, useContext } from 'react';

// Create a context for user
export const UserContext = createContext();

// Create a provider component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null); // Default is no user

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook to use UserContext in any component
export const useUser = () => {
  return useContext(UserContext);
};
